import React, { useEffect, useState } from 'react';
import { FaSearch, FaTrash, FaPlus } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function BannerList() {
    const [banners, setBanners] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(100);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [bannerId, setBannerId] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    const [deviceType, setDeviceType] = useState('desktop');
    const [preview, setPreview] = useState(null);
    const [sequence, setSequence] = useState(0);
    const [active, setActive] = useState(true);
    const [productImageUrl, setProductImageUrl] = useState('');

    const fetchBanners = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/banner-images`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const result = await res.json();
            setBanners(result.banners || result || []);
        } catch (error) {
            console.error('Error fetching banners:', error);
        }
    };

    useEffect(() => {
        fetchBanners();
    }, []);

    const filteredBanners = banners.filter(banner =>
        Object.values(banner).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const currentBanners = filteredBanners.slice(indexOfLastItem - itemsPerPage, indexOfLastItem);
    const totalPages = Math.ceil(filteredBanners.length / itemsPerPage);

    const handleAddBanner = async () => {
        const token = localStorage.getItem('authToken');
        const formData = new FormData();
        formData.append('image_file', imageFile);
        formData.append('device_type', deviceType);
        formData.append('sequence', sequence);
        formData.append('active', active);
        formData.append('Product_image_url', productImageUrl);


        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/banner-images`, {
                method: 'POST',
                headers: { Authorization: `Bearer ${token}` },
                body: formData
            });
            if (!res.ok) throw new Error('Failed to upload banner');
            fetchBanners();
            resetForm();
            setShowModal(false);
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteClick = (id) => {
        setBannerId(id);
        setShowDeleteModal(true);
    };

    const handleDeleteBanner = async () => {
        const token = localStorage.getItem('authToken');
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/banner-images/${bannerId}`, {
                method: 'DELETE',
                headers: { Authorization: `Bearer ${token}` },
            });
            fetchBanners();
            setShowDeleteModal(false);
        } catch (err) {
            console.error('Error deleting banner:', err);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const resetForm = () => {
        setImageFile(null);
        setPreview(null);
        setDeviceType('desktop');
        setSequence(0);
        setActive(true);
        setProductImageUrl(''); // ✅ reset field
    };

    return (
        <div className="container" style={{ marginTop: '80px' }}>
            <h2 className="text-primary">Banner Images</h2>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="input-group me-3" style={{ maxWidth: '300px' }}>
                    <span className="input-group-text bg-primary text-white">
                        <FaSearch />
                    </span>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search banners..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <button className="btn btn-success" onClick={() => setShowModal(true)}>
                    <FaPlus /> Add Banner
                </button>
            </div>

            <table className="table table-bordered table-striped">
                <thead className="table-primary">
                    <tr>
                        <th>ID</th>
                        <th>Device</th>
                        <th>Image</th>
                        <th>Sequences</th>
                        <th>Status</th>
                        <th>Product URL</th>
                        <th>Created At</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentBanners.map((banner) => (
                        <tr key={banner.banner_imagesId}>
                            <td>{banner.banner_imagesId}</td>
                            <td>{banner.device_type}</td>
                            <td><img src={banner.image_url} alt="" width="100" /></td>
                            <td>{banner.sequence}</td>
                            <td>{banner.active ? 'Active' : 'Deactive'}</td>
<td>
  {banner.Product_image_url ? (
    <span>{banner.Product_image_url}</span>
  ) : (
    <span className="text-muted">None</span>
  )}
</td>
                            <td>{new Date(banner.CreatedAt).toLocaleDateString()}</td>
                            <td>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteClick(banner.banner_imagesId)}>
                                    <FaTrash /> Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <nav>
                <ul className="pagination justify-content-center">
                    {[...Array(totalPages)].map((_, i) => (
                        <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                                {i + 1}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            <Modal show={showModal} onHide={() => { setShowModal(false); resetForm(); }}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Banner</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Device</Form.Label>
                            <Form.Select value={deviceType} onChange={(e) => setDeviceType(e.target.value)}>
                                <option value="desktop">Desktop</option>
                                <option value="mobile">Mobile</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Sequence</Form.Label>
                            <Form.Control
                                type="number"
                                value={sequence}
                                onChange={(e) => setSequence(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Active"
                                checked={active}
                                onChange={(e) => setActive(e.target.checked)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Upload Image</Form.Label>
                            <Form.Control type="file" accept="image/*" onChange={handleImageChange} />
                            {preview && (
                                <img src={preview} alt="Preview" className="img-fluid mt-2" />
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Redirect URL (Product/Category Link)</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="https://example.com/shirts"
                                value={productImageUrl}
                                onChange={(e) => setProductImageUrl(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowModal(false); resetForm(); }}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddBanner}>
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this banner?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                    <Button variant="danger" onClick={handleDeleteBanner}>Delete</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default BannerList;